module.exports = __webpack_public_path__ + "static/media/welcome.02e9dc4a.jpg";